"use client";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

type DebuggerToggles = {
  scrollSpy: boolean;
  commission: boolean;
};

type DebuggerMenuProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  toggles: DebuggerToggles;
  onToggleChange: (key: keyof DebuggerToggles) => void;
  onDisableAll: () => void;
};

export function DebuggerMenu({
  isOpen,
  onOpenChange,
  toggles,
  onToggleChange,
  onDisableAll,
}: DebuggerMenuProps) {
  return (
    <div className="fixed bottom-4 right-4 z-9999">
      <Popover
        open={isOpen}
        onOpenChange={onOpenChange}
      >
        <PopoverTrigger asChild>
          <button
            type="button"
            className="rounded-full border border-slate-300/70 bg-white/90 px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-slate-900 shadow-sm backdrop-blur transition hover:bg-white"
            aria-expanded={isOpen}
            aria-label="Toggle visual debugger"
          >
            Debug
          </button>
        </PopoverTrigger>
        <PopoverContent
          align="end"
          side="top"
          sideOffset={12}
          className="w-64 rounded-xl border border-slate-200/80 bg-white/95 p-4 text-slate-900 shadow-lg backdrop-blur"
        >
          <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            Visual debugger
          </div>
          <div className="mt-3 space-y-2">
            <label className="flex items-center justify-between gap-3 text-sm">
              <span>ScrollSpy helpers</span>
              <input
                type="checkbox"
                checked={toggles.scrollSpy}
                onChange={() => onToggleChange("scrollSpy")}
                className="h-4 w-4 accent-slate-900"
              />
            </label>
            <label className="flex items-center justify-between gap-3 text-sm">
              <span>Commercial data</span>
              <input
                type="checkbox"
                checked={toggles.commission}
                onChange={() => onToggleChange("commission")}
                className="h-4 w-4 accent-slate-900"
              />
            </label>
          </div>
          <div className="mt-3 border-t border-slate-200 pt-3">
            <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">
              Actions
            </div>
            <div className="mt-2 space-y-2">
              <button
                type="button"
                onClick={() => {
                  sessionStorage.removeItem("primeDayPopupDismissed");
                  window.dispatchEvent(
                    new Event("debug:force-promotion-popup"),
                  );
                  window.dispatchEvent(
                    new Event("debug:force-prime-day-popup"),
                  );
                }}
                className="w-full rounded-md bg-slate-100 px-2 py-1.5 text-left text-sm transition hover:bg-slate-200"
              >
                Show Promotion Popup
              </button>
            </div>
          </div>
          <div className="mt-4 flex items-center justify-between gap-2 text-xs text-slate-500">
            <span>
              {toggles.scrollSpy || toggles.commission ? "Active" : "Idle"}
            </span>
            <button
              type="button"
              onClick={onDisableAll}
              className="text-slate-500 transition hover:text-slate-900"
            >
              Disable all
            </button>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
